// extracted by mini-css-extract-plugin
export default {"menuBtn":"HamburgerMenu_menuBtn__-5qYV","menuBtnBurger":"HamburgerMenu_menuBtnBurger__xClON","open":"HamburgerMenu_open__EKWUf"};